import { z } from "zod";

export const showConfigSchema = z.object({
  /** Particles needed to trigger the pattern stage. The main admin knob. */
  patternThreshold: z.number().int().min(1).max(100_000),
  /** How long the pattern animation runs before the stage becomes `completed`. */
  patternDurationMs: z.number().int().min(1_000).max(600_000),
  /**
   * false = the phone must perform the separate release action to spawn a particle.
   * true  = submitting the form releases immediately.
   */
  autoReleaseOnSubmit: z.boolean(),
  /** Hard cap; the visuals preallocates buffers for this many particles. */
  particleCap: z.number().int().min(1).max(100_000),
});
export type ShowConfig = z.infer<typeof showConfigSchema>;

/** Admin config PATCH: any subset, but not an empty object. */
export const showConfigPatchSchema = showConfigSchema
  .partial()
  .refine((v) => Object.keys(v).length > 0, { message: "at least one field required" });
export type ShowConfigPatch = z.infer<typeof showConfigPatchSchema>;
